import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { TabCertificateComponent } from 'src/app/components/tab-certificate/tab-certificate.component';
import { ActivatedRoute } from '@angular/router';
import { CST_CERTIFICATE_STYLE } from 'src/app/classes/const';
import { AppToolbarService } from 'src/app/components/toolbar/services/app-toolbar.service';

@Component({
  selector: 'app-list-certificats',
  templateUrl: './list-certificats.component.html',
  styleUrls: ['./list-certificats.component.css']
})
export class ListCertificatsComponent implements OnInit {

  @ViewChild('matTabGroup', { static: true }) mMatTabGroup!: MatTabGroup;
  @ViewChild('Certificats', { static: true }) CerficatsTab!: TabCertificateComponent;

  constructor(private mRoute: ActivatedRoute,
              private mToolbat: AppToolbarService) {

  }

  ngOnInit() {
    this.mToolbat.toolbarPageTitle = 'Certificats';
    this.mRoute.params.subscribe(
      param => {
        // On cherche dans les argument de la page le type de certificat a aficher
        const index = (param.showby ? param.showby : CST_CERTIFICATE_STYLE.bySite);
        this.mMatTabGroup.selectedIndex = index;
        this.onActiveTabChange(index);
      });
  }

  /**
   * Appeler sur l'HTML
   * @param index Index de l'onglet
   */
  onActiveTabChange(index: number) {
    this.CerficatsTab.setComponentStyle(index);
  }


}
